<template>
  <div class="card">
    <!--begin::Card body-->
    <div class="card-body p-0">
      <!--begin::Heading-->
      <div class="card-px text-left py-0 my-10">
        <h2 v-if="tipo !== 'nuevo'" class="fs-1x fw-bolder mb-10">
          Registro de
          {{
            tipo === "traslados"
              ? "Traslado"
              : tipo === "salidas"
              ? "Salida Judicial"
              : tipo === "fallecimiento"
              ? "Fallecimiento de Privado de Libertad"
              : tipo === "evasion"
              ? "Evasión de Privado de Libertad"
              : ""
          }}
        </h2>
        <h2 v-else-if="tipo === 'nuevo'" class="fs-1x fw-bolder mb-10">
          {{
            tipo_add === "register"
              ? "Registrar nueva orden judicial"
              : "Añadir orden judicial al proceso actual"
          }}
        </h2>
        <h2 v-else class="fs-1x fw-bolder mb-10">Registro de Orden Judicial</h2>
        <p v-if="tipo" class="text-gray-600 fs-6 fw-bold mb-5">
          <span v-if="tipo !== 'nuevo'"
            >Obtención de datos para
            {{
              tipo === "traslados"
                ? "Traslado"
                : tipo === "salidas"
                ? "Salida Judicial"
                : tipo === "fallecimiento"
                ? "registro de fallecimiento"
                : tipo === "evasion"
                ? "registro de evasión"
                : ""
            }}
            del ppl</span
          >
          <span v-else>
            <p>
              Obtención de datos para
              {{
                tipo_add === "register"
                  ? "registrar nueva orden judicial"
                  : "añadir orden judicial"
              }}
              del ppl
            </p></span
          >
        </p>

        <p></p>
        <div class="alinear row">
          <div class="col-md-6">
            <p class="round3">
              Los campos marcados con (<span style="color: red"> * </span>) son
              de llenado obligatorio.
            </p>
          </div>
          <div class="image col-md-4">
            <p>
              <strong>NOMBRE PPL :</strong> {{ nombre_completo }} <br />
              <strong>DOCUMENTO DE IDENTIDAD :</strong> {{ doc_identidad
              }}<br />
              <strong>CÓDIGO FILE :</strong> {{ codigo_file_ppl }} <br />
              <strong>ESTADO JUDICIAL :</strong> {{ tipo_mandamiento }} <br />
            </p>
          </div>
          <div class="image col-md-2">
            <img
              src="../../../public/media/blank.png"
              class="img-fluid img-thumbnail"
              width="150"
              height="150"
              alt="without_image"
              v-if="!fotografia || fotografia === 'null'"
            />
            <img
              v-else
              :src="fotografia"
              class="img-fluid img-thumbnail"
              width="150"
              height="150"
              alt="segipImage"
            />
          </div>
        </div>
        <div class="row">
          <!-- fecha orden -->
          <div
            v-if="tipo !== 'fallecimiento' && tipo !== 'evasion'"
            class="col-md-4 mt-3"
          >
            <label v-if="tipo == 'traslados'" class="form-label required"
              >Fecha orden de traslado:</label
            >
            <label v-else class="form-label required"
              >Fecha orden judicial:</label
            >
            <Datepicker
              uid="fecha_orden"
              v-model="state.formData.fecha_orden"
              type="date"
              locale="es"
              cancelText="Cancelar"
              selectText="Seleccionar"
              monthNameFormat="long"
              :enableTimePicker="false"
              :format="format"
              :previewFormat="format"
              :maxDate="currentDate"
              required
            ></Datepicker>
            <div
              class="input-errors"
              v-for="error of v$.formData.fecha_orden.$errors"
              :key="error.$uid"
            >
              <span class="text-danger" v-if="error.$validator == 'required'"
                >La fecha de la orden es requerida</span
              >
            </div>
          </div>
          <!-- fecha fallecimiento -->
          <div v-else-if="tipo === 'fallecimiento'" class="col-md-4 mt-3">
            <label class="form-label required">Fecha y hora del Deceso:</label>
            <Datepicker
              uid="fecha_deceso"
              v-model="state.formData.fecha_deceso"
              type="date"
              locale="es"
              cancelText="Cancelar"
              selectText="Seleccionar"
              monthNameFormat="long"
              :enableTimePicker="true"
              :format="formatDateAndHours"
              :previewFormat="formatDateAndHours"
              :maxDate="currentDate"
              required
            ></Datepicker>
            <div
              class="input-errors"
              v-for="error of v$.formData.fecha_deceso.$errors"
              :key="error.$uid"
            >
              <span class="text-danger" v-if="error.$validator == 'required'"
                >La fecha y hora del fallecimiento es requerida</span
              >
            </div>
          </div>
          <!-- lugar deceso -->
          <div v-if="tipo === 'fallecimiento'" class="col-md-4 mt-3">
            <label class="form-label required">Lugar del Deceso:</label>
            <input
              type="text"
              class="form-control fuente"
              id="nombre_juzgado"
              style="text-transform: uppercase"
              v-model.trim="state.formData.lugar_deceso"
            />
            <div
              class="input-errors"
              v-for="error of v$.formData.lugar_deceso.$errors"
              :key="error.$uid"
            >
              <span class="text-danger" v-if="error.$validator == 'required'"
                >El lugar del deceso es requerido</span
              >
            </div>
          </div>
          <!--  certificado de defunción-->
          <div v-if="tipo === 'fallecimiento'" class="col-md-4 mt-3">
            <label class="form-label required"
              >Nro. Certificado de Defunción:</label
            >
            <input
              type="text"
              class="form-control fuente"
              id="nombre_juzgado"
              style="text-transform: uppercase"
              v-model.trim="state.formData.certificado_defuncion"
            />
            <div
              class="input-errors"
              v-for="error of v$.formData.certificado_defuncion.$errors"
              :key="error.$uid"
            >
              <span class="text-danger" v-if="error.$validator == 'required'"
                >El número de certificado de defunción es requerido</span
              >
            </div>
          </div>
          <!-- causa de la muerte -->
          <div v-if="tipo === 'fallecimiento'" class="col-md-4 mt-3">
            <label class="form-label required">Causa del deceso:</label>
            <select
              v-model.trim="state.formData.id_tipo_deceso"
              class="form-select fuente"
              aria-label="select"
            >
              <option
                v-for="(list, key) in typeOfDeath"
                :value="list.id_tipo_deceso"
                :key="key"
              >
                {{ list.nombre_tipo_deceso }}
              </option>
            </select>
            <div
              class="input-errors"
              v-for="error of v$.formData.id_tipo_deceso.$errors"
              :key="error.$uid"
            >
              <span class="text-danger" v-if="error.$validator == 'required'"
                >La causa del deceso es requerida</span
              >
            </div>
          </div>
          <!-- fecha traslado -->
          <div v-if="tipo == 'traslados'" class="col-md-4 mt-3">
            <label class="form-label required">Fecha traslado:</label>
            <Datepicker
              uid="fecha_traslado"
              v-model="state.formData.fecha_traslado"
              type="date"
              locale="es"
              cancelText="Cancelar"
              selectText="Seleccionar"
              monthNameFormat="long"
              :enableTimePicker="false"
              :format="format"
              :previewFormat="format"
              :maxDate="currentDate"
              required
            ></Datepicker>
            <div
              class="input-errors"
              v-for="error of v$.formData.fecha_traslado.$errors"
              :key="error.$uid"
            >
              <span class="text-danger" v-if="error.$validator == 'required'"
                >La fecha de traslado es requerida</span
              >
            </div>
          </div>
          <!-- fecha libertad -->
          <div v-if="tipo === 'salidas'" class="col-md-4 mt-3">
            <label class="form-label required"
              >Fecha Salida Recinto Penitenciario:</label
            >
            <Datepicker
              uid="fecha_libertad"
              v-model="state.formData.fecha_libertad"
              type="date"
              locale="es"
              cancelText="Cancelar"
              selectText="Seleccionar"
              monthNameFormat="long"
              :enableTimePicker="false"
              :format="format"
              :previewFormat="format"
              :maxDate="currentDate"
              required
            ></Datepicker>
            <div
              class="input-errors"
              v-for="error of v$.formData.fecha_libertad.$errors"
              :key="error.$uid"
            >
              <span class="text-danger" v-if="error.$validator == 'required'"
                >La fecha de salida es requerida</span
              >
            </div>
          </div>
          <!-- fecha ingreso al recinto penitenciario -->
          <div v-if="tipo === 'nuevo'" class="col-md-4 mt-3">
            <label
              v-if="tipo === 'nuevo' && tipo_add === 'add'"
              class="form-label required"
              >Fecha ingreso Recinto Penitenciario:</label
            >
            <label
              v-if="tipo === 'nuevo' && tipo_add === 'register'"
              class="form-label required"
              >Fecha registro orden judicial:</label
            >
            <Datepicker
              uid="fecha_ingreso"
              v-model="state.formData.fecha_ingreso"
              type="date"
              locale="es"
              cancelText="Cancelar"
              selectText="Seleccionar"
              monthNameFormat="long"
              :enableTimePicker="false"
              :format="format"
              :maxDate="currentDate"
              required
              :disabled="tipo === 'nuevo' && tipo_add === 'add'"
              :previewFormat="format"
            ></Datepicker>
          </div>
          <!-- tipo mandamiento -->
          <div
            v-if="tipo !== 'fallecimiento' && tipo !== 'evasion'"
            class="col-md-4 mt-3"
          >
            <label v-if="tipo == 'traslados'" class="form-label required"
              >Tipo de Traslado:</label
            >
            <label v-else-if="tipo == 'salidas'" class="form-label required"
              >Tipo de Resolución:</label
            >
            <label v-else class="form-label required">Tipo Mandamiento:</label>
            <select
              class="form-select fuente"
              aria-label="select"
              v-model.trim="state.formData.tipo_mandamiento"
              :onchange="
                habilitarCamposPorTipoMandamiento(
                  state.formData.tipo_mandamiento
                )
              "
            >
              <option
                v-for="(list, key) in typeOrdersList"
                :value="list.id_tipo_mandamiento"
                :key="key"
                :disabled="
                  (descripcion_tipo_mandamiento === 'PREVENTIVO' ||
                    descripcion_tipo_mandamiento === 'APREMIO') &&
                  list.descripcion_tipo_mandamiento === 'SALIDA PROLONGADA'
                "
              >
                {{ list.descripcion_tipo_mandamiento }}
              </option>
            </select>
            <div
              class="input-errors"
              v-for="error of v$.formData.tipo_mandamiento.$errors"
              :key="error.$uid"
            >
              <span
                class="text-danger"
                v-if="error.$validator == 'required' && tipo == 'traslados'"
                >El tipo de traslado es requerido</span
              >
              <span
                class="text-danger"
                v-if="error.$validator == 'required' && tipo == 'salidas'"
                >El tipo de orden judicial es requerido</span
              >
              <span
                class="text-danger"
                v-if="error.$validator == 'required' && tipo == 'nuevo'"
                >El mandamiento es requeirdo</span
              >
            </div>
          </div>
          <!-- tipo libertad definitiva -->
          <div v-if="esLibertadDefinitiva" class="col-md-4 mt-3">
            <label class="form-label required"
              >Tipo de libertad definitiva:</label
            >
            <select
              class="form-select fuente"
              aria-label="select"
              v-model.trim="state.formData.tipo_libertad_definitiva"
            >
              <option v-if="tipo_mandamiento === 'PREVENTIVO' && tipo_mandamiento==='SENTENCIADO'" value="AMNISTIA">
                AMNISTIA
              </option>
              <option
                v-if="tipo_mandamiento === 'SENTENCIADO'"
                value="CUMPLIMIENTO DE CONDENA"
              >
                CUMPLIMIENTO DE CONDENA
              </option>
              <option v-if="tipo_mandamiento === 'SENTENCIADO'" value="INDULTO">
                INDULTO
              </option>
              <option
                v-if="
                  tipo_mandamiento === 'PREVENTIVO' ||
                  tipo_mandamiento === 'APREMIO'
                "
                value="LIBERTAD PURA Y SIMPLE"
              >
                LIBERTAD PURA Y SIMPLE
              </option>
            </select>
            <div
              class="input-errors"
              v-for="error of v$.formData.tipo_libertad_definitiva.$errors"
              :key="error.$uid"
            >
              <span class="text-danger" v-if="error.$validator == 'required'"
                >El tipo de traslado es requerido</span
              >
            </div>
          </div>
          <!-- motivo traslado -->
          <div v-if="tipo === 'traslados'" class="col-md-4 mt-3">
            <label class="form-label required">Motivo de traslado:</label>
            <input
              type="text"
              class="form-control fuente"
              id="motivo_traslado"
              style="text-transform: uppercase"
              v-model.trim="state.formData.motivo_traslado"
            />
            <div
              class="input-errors"
              v-for="error of v$.formData.motivo_traslado.$errors"
              :key="error.$uid"
            >
              <span class="text-danger" v-if="error.$validator == 'required'"
                >El motivo de traslado es requerido</span
              >
            </div>
          </div>
          <!--  años de sentencia-->
          <div v-if="tiempo_sentencia" class="col-md-3 mt-3">
            <label class="form-label required">Años de sentencia:</label>
            <input
              type="number"
              class="form-control fuente"
              min="0"
              max="30"
              maxlength="2"
              pattern="^(0|[1-9][0-9]?)$"
              id="anios_sentencia"
              placeholder="ingresar de 0 a 30 (años)"
              v-model.trim="state.formData.anios_sentencia"
              @keyup="deleteZeros"
              @input="cambioMeses(state.formData.anios_sentencia)"
            />
            <div
              class="input-errors"
              v-for="error of v$.formData.anios_sentencia.$errors"
              :key="error.$uid"
            >
              <span class="text-danger" v-if="error.$validator == 'required'"
                >Los años de sentencia son requeridos</span
              >
            </div>
          </div>
          <!-- meses de sentencia -->
          <div v-if="tiempo_sentencia" class="col-md-3 mt-3">
            <label class="form-label required">Meses de sentencia:</label>
            <input
              name="meses_sentencia"
              type="number"
              class="form-control fuente"
              min="0"
              max="11"
              maxlength="2"
              pattern="^(0|[1-9][0-9]?)$"
              id="anios_sentencia"
              placeholder="ingresar de 0 a 11 (meses)"
              v-model.trim="state.formData.meses_sentencia"
              :disabled="
                !state.formData.anios_sentencia ||
                state.formData.anios_sentencia == 30
              "
              @keyup="deleteZeros"
              @input="calcularFechaSalida(state.formData.meses_sentencia)"
            />
            <div
              class="input-errors"
              v-for="error of v$.formData.meses_sentencia.$errors"
              :key="error.$uid"
            >
              <span class="text-danger" v-if="error.$validator == 'required'"
                >Los meses de sentencia son requeridos</span
              >
            </div>
          </div>
          <!--  fecha salida según sentencia-->
          <div v-if="tiempo_sentencia" class="col-md-3 mt-3">
            <label class="form-label required"
              >Fecha salida según sentencia:</label
            >
            <Datepicker
              uid="fecha_salida"
              v-model="state.formData.fecha_salida"
              type="date"
              locale="es"
              cancelText="Cancelar"
              selectText="Seleccionar"
              monthNameFormat="long"
              :enableTimePicker="false"
              :format="format"
              :previewFormat="format"
              :minDate="currentDate"
              :disabled="!state.formData.habilitarFechaSalida"
              required
            ></Datepicker>
          </div>
          <!-- activar fecha salida manual -->
          <div v-if="tiempo_sentencia" class="col-md-3 mt-3 float-right">
            <label class="form-label">Fecha salida manual:</label> <br />
            <div class="form-check form-switch mt-2">
              <input
                class="form-check-input"
                type="checkbox"
                id="flexSwitchCheckDefault"
                v-model="state.formData.habilitarFechaSalida"
              />
              <label class="form-check-label" for="flexSwitchCheckDefault">
                {{
                  state.formData.habilitarFechaSalida == true
                    ? "Habilitado"
                    : "Deshabilitado"
                }}</label
              >
            </div>
          </div>
          <!-- nombre juez -->
          <div
            v-if="tipo !== 'fallecimiento' && tipo !== 'evasion'"
            class="col-md-4 mt-3"
          >
            <label
              v-if="
                tipo == 'traslados' &&
                tipo_traslado == 'TRASLADO ADMINISTRATIVO'
              "
              class="form-label required"
              >Nombre Autoridad:</label
            >
            <label
              v-else-if="
                tipo == 'traslados' && tipo_traslado == 'TRASLADO JUDICIAL'
              "
              class="form-label required"
              >Nombre Juez:</label
            >
            <label v-else class="form-label required"
              >Nombre completo del juez:</label
            >
            <input
              type="text"
              class="form-control fuente"
              id="juez"
              style="text-transform: uppercase"
              v-model.trim="state.formData.nombre_juez"
            />
            <div
              class="input-errors"
              v-for="error of v$.formData.nombre_juez.$errors"
              :key="error.$uid"
            >
              <span
                class="text-danger"
                v-if="
                  error.$validator == 'required' &&
                  tipo == 'traslados' &&
                  tipo_traslado == 'TRASLADO ADMINISTRATIVO'
                "
                >El nombre del la autoridad es requerido</span
              >
              <span
                class="text-danger"
                v-else-if="
                  error.$validator == 'required' &&
                  tipo == 'traslados' &&
                  tipo_traslado == 'TRASLADO JUDICIAL'
                "
                >El nombre del juez es requerido</span
              >
              <span class="text-danger" v-else
                >El nombre del juez es requerido</span
              >
            </div>
          </div>
          <!-- nombre juzgado -->
          <div
            v-if="tipo !== 'fallecimiento' && tipo !== 'evasion'"
            class="col-md-4 mt-3"
          >
            <label
              v-if="
                tipo == 'traslados' &&
                tipo_traslado == 'TRASLADO ADMINISTRATIVO'
              "
              class="form-label required"
              >Administración:</label
            >
            <label
              v-else-if="
                tipo == 'traslados' && tipo_traslado == 'TRASLADO JUDICIAL'
              "
              class="form-label required"
              >Juzgado:</label
            >
            <label v-else class="form-label required">Juzgado:</label>
            <input
              type="text"
              class="form-control fuente"
              id="nombre_juzgado"
              style="text-transform: uppercase"
              v-model.trim="state.formData.nombre_juzgado"
            />
            <div
              class="input-errors"
              v-for="error of v$.formData.nombre_juzgado.$errors"
              :key="error.$uid"
            >
              <span class="text-danger" v-if="error.$validator == 'required'"
                >El nombre del juzgado es requerido</span
              >
            </div>
          </div>
          <!-- tipo juzgado -->
          <div
            v-if="tipo !== 'fallecimiento' && tipo !== 'evasion'"
            class="col-md-4 mt-3"
          >
            <label class="form-label required">Tipo Juzgado:</label>
            <select
              v-model="state.formData.tipo_juzgado"
              class="form-select fuente"
              aria-label="select"
            >
              <option
                v-for="(list, key) in typeCourtsList"
                :value="list.id_tipo_juzgado"
                :key="key"
                :disabled="
                  (list.descripcion_tipo_juzgado === 'NO APLICA' &&
                    (tipo === 'salidas' || tipo === 'nuevo')) ||
                  (list.descripcion_tipo_juzgado === 'NO APLICA' &&
                    tipo == 'traslados' &&
                    tipo_traslado == 'TRASLADO JUDICIAL') ||
                  (list.descripcion_tipo_juzgado !== 'NO APLICA' &&
                    tipo == 'traslados' &&
                    tipo_traslado == 'TRASLADO ADMINISTRATIVO')
                "
              >
                {{ list.descripcion_tipo_juzgado }}
              </option>
            </select>
            <div
              class="input-errors"
              v-for="error of v$.formData.tipo_juzgado.$errors"
              :key="error.$uid"
            >
              <span class="text-danger" v-if="error.$validator == 'required'"
                >El tipo de juzgado es requerido</span
              >
            </div>
          </div>
          <!-- tipo código -->
          <div
            v-if="tipo !== 'fallecimiento' && tipo !== 'evasion'"
            class="col-md-4 mt-3"
          >
            <label class="form-label required">Tipo de Código:</label>
            <select
              v-model.trim="state.formData.tipo_codigo"
              class="form-select fuente"
              aria-label="select"
              :onchange="disabledCodMandamiento(state.formData.tipo_codigo)"
            >
              <option
                v-for="(list, key) in typeCodesList"
                :value="list.id_tipo_codigo"
                :key="key"
                :disabled="
                  (list.nombre_codigo === 'RESOLUCIÓN ADMINISTRATIVA' &&
                    (tipo === 'salidas' || tipo === 'nuevo')) ||
                  (list.nombre_codigo === 'RESOLUCIÓN ADMINISTRATIVA' &&
                    tipo == 'traslados' &&
                    tipo_traslado == 'TRASLADO JUDICIAL') ||
                  (list.nombre_codigo !== 'RESOLUCIÓN ADMINISTRATIVA' &&
                    tipo == 'traslados' &&
                    tipo_traslado == 'TRASLADO ADMINISTRATIVO')
                "
              >
                {{ list.nombre_codigo }}
              </option>
            </select>
            <div
              class="input-errors"
              v-for="error of v$.formData.tipo_codigo.$errors"
              :key="error.$uid"
            >
              <span class="text-danger" v-if="error.$validator == 'required'"
                >El tipo de código es requerido</span
              >
            </div>
          </div>
          <!-- código único -->
          <div
            v-if="tipo !== 'fallecimiento' && tipo !== 'evasion'"
            class="col-md-4 mt-3"
          >
            <label
              v-if="
                tipo == 'traslados' &&
                tipo_traslado == 'TRASLADO ADMINISTRATIVO'
              "
              class="form-label required"
              >Número de resolución:</label
            >
            <label
              v-else-if="
                tipo == 'traslados' && tipo_traslado == 'TRASLADO JUDICIAL'
              "
              class="form-label required"
              >Código único:</label
            >
            <label v-else class="form-label required"
              >Código único de mandamiento:</label
            >
            <input
              type="text"
              class="form-control fuente"
              id="cod_mandamiento"
              style="text-transform: uppercase"
              v-model.trim="state.formData.codigo_mandamiento"
              :disabled="!codMandamiento"
            />
            <div
              class="input-errors"
              v-for="error of v$.formData.codigo_mandamiento.$errors"
              :key="error.$uid"
            >
              <span class="text-danger" v-if="error.$validator == 'required'"
                >El código único es requerido</span
              >
            </div>
          </div>
          <!-- fecha_evasión -->
          <div v-if="tipo === 'evasion'" class="col-md-5 mt-3">
            <label class="form-label required"
              >Fecha y hora de la Evasión:</label
            >
            <Datepicker
              uid="fecha_evasion"
              v-model="state.formData.fecha_evasion"
              type="date"
              locale="es"
              cancelText="Cancelar"
              selectText="Seleccionar"
              monthNameFormat="long"
              :enableTimePicker="true"
              :format="formatDateAndHours"
              :previewFormat="formatDateAndHours"
              :maxDate="currentDate"
              required
              @update:modelValue="formatDateTime"
            ></Datepicker>
            <div
              class="input-errors"
              v-for="error of v$.formData.fecha_evasion.$errors"
              :key="error.$uid"
            >
              <span class="text-danger" v-if="error.$validator == 'required'"
                >La fecha y hora de la evasión es requerida</span
              >
            </div>
          </div>
          <!-- descripción evasión -->
          <div v-if="tipo === 'evasion'" class="col-md-12 mt-3">
            <label class="form-label required">Descripción evación:</label>
            <textarea
              class="form-control fuente"
              id="descripcion_evasion"
              min="1"
              pattern="^[0-9]+"
              style="text-transform: uppercase"
              v-model.trim="state.formData.descripcion_evasion"
            />
            <div
              class="input-errors"
              v-for="error of v$.formData.descripcion_evasion.$errors"
              :key="error.$uid"
            >
              <span class="text-danger" v-if="error.$validator == 'required'"
                >La descripción de la evasión es requerida</span
              >
            </div>
          </div>
          <!-- centro penitenciario actual -->
          <div class="col-md-4 mt-3">
            <label v-if="tipo === 'traslados'" class="form-label required"
              >Recinto penitenciario actual:</label
            >
            <label v-else class="form-label required"
              >Recinto penitenciario:</label
            >
            <select
              v-model="state.formData.centro_penitenciario"
              class="form-select fuente"
              aria-label="select"
              disabled
            >
              <option
                v-for="(list, key) in prisionNamesList"
                :value="list.id_recinto_penitenciario"
                :key="key"
              >
                {{ list.nombre_recinto_penitenciario }}
              </option>
            </select>
          </div>
          <!-- centro penitenciario de traslado -->
          <div v-if="tipo === 'traslados'" class="col-md-4 mt-3">
            <label class="form-label required">Recinto de traslado:</label>
            <select
              v-model.trim="state.formData.centro_penitenciario_traslado"
              class="form-select fuente"
              aria-label="select"
            >
              <option
                v-for="(list, key) in prisionNamesList"
                :value="list.id_recinto_penitenciario"
                :key="key"
                :disabled="
                  state.formData.centro_penitenciario ===
                  list.id_recinto_penitenciario
                "
              >
                {{ list.nombre_recinto_penitenciario }}
              </option>
            </select>
            <div
              class="input-errors"
              v-for="error of v$.formData.centro_penitenciario_traslado.$errors"
              :key="error.$uid"
            >
              <span class="text-danger" v-if="error.$validator == 'required'"
                >El centro penitenciario de traslado es requerido</span
              >
            </div>
          </div>
          <!-- delitos -->
          <div class="col-md-8 mt-3">
            <!--begin::Label-->
            <label class="d-flex align-items-center fs-6 fw-bold mb-2">
              <span class="required">Delitos</span>
              <i
                class="fas fa-exclamation-circle ms-2 fs-7"
                data-bs-toggle="tooltip"
                title="Puede seleccionar uno o más delitos"
              ></i>
            </label>
            <el-form>
              <el-form-item>
                <el-select
                  v-model="state.formData.delitos"
                  multiple
                  placeholder="Presione para seleccionar"
                  style="display: block"
                  :disabled="id_orden_judicial !== '0'"
                >
                  <el-option
                    v-for="(list, key) in crimesList"
                    :key="key"
                    :label="list.descripcion_delito"
                    :value="list.id_delito"
                    :disabled="
                      list.descripcion_delito !== 'ASISTENCIA FAMILIAR' &&
                      list.descripcion_delito !== 'BENEFICIOS SOCIALES' &&
                      descripcion_tipo_mandamiento === 'APREMIO'
                    "
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <div
              class="input-errors"
              v-for="error of v$.formData.delitos.$errors"
              :key="error.$uid"
            >
              <span class="text-danger" v-if="error.$validator == 'required'"
                >Los delitos son requeridos</span
              >
            </div>
          </div>
          <!-- motivo extramuro -->
          <div v-if="esExtramuro" class="col-md-4 mt-3">
            <label class="form-label required">Motivo salida extramuro:</label>
            <select
              v-model.trim="state.formData.motivo_extramuro"
              class="form-select fuente"
              aria-label="select"
            >
              <option value="TRABAJO">TRABAJO</option>
              <option value="ESTUDIO">ESTUDIO</option>
            </select>
            <div
              class="input-errors"
              v-for="error of v$.formData.motivo_extramuro.$errors"
              :key="error.$uid"
            >
              <span class="text-danger" v-if="error.$validator == 'required'"
                >El motivo del extramuro es requerido</span
              >
            </div>
          </div>
          <!-- seguido por -->
          <div v-if="tipo === 'nuevo'" class="col-md-4 mt-3">
            <label class="form-label">Seguido por:</label>
            <input
              type="text"
              class="form-control fuente"
              id="seguido_por"
              style="text-transform: uppercase"
              v-model.trim="state.formData.seguido_por"
            />
          </div>
          <div v-if="esDetencionDomiciliaria || esExtramuro" class="row">
            <!-- Lugar detención domiciliaria o extramuro-->
            <div class="col-md-12 mt-3">
              <label v-if="!esExtramuro" class="form-label required"
                >Lugar detención domiciliaria:</label
              >
              <label v-if="esExtramuro" class="form-label required"
                >Lugar Extramuro:</label
              >
              <textarea
                class="form-control fuente"
                id="lugar_detencion_domiciliaria"
                style="text-transform: uppercase"
                v-model.trim="state.formData.lugar_detencion_domiciliaria"
              />
              <div
                class="input-errors"
                v-for="error of v$.formData.lugar_detencion_domiciliaria
                  .$errors"
                :key="error.$uid"
              >
                <span
                  class="text-danger"
                  v-if="!esExtramuro && error.$validator == 'required'"
                  >El lugar de detención domiciliaria es requerido</span
                >
                <span
                  class="text-danger"
                  v-if="esExtramuro && error.$validator == 'required'"
                  >La ubicación del extramuro es requerida</span
                >
              </div>
            </div>
            <!-- ¿Tiene custodio policial?-->
            <div v-if="!esExtramuro" class="col-md-3 mt-3 float-left">
              <label class="form-label required"
                >¿Tiene custodios policiales?:</label
              >
              <br />
              <div class="form-check form-switch mt-2">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="tiene_custodio"
                  v-model="state.formData.tiene_custodio"
                  :onClick="limpiarCustodios"
                />
                <label class="form-check-label" for="flexSwitchCheckDefault">
                  {{
                    state.formData.tiene_custodio == true ? "Sí" : "No"
                  }}</label
                >
              </div>
            </div>
            <!-- nombre custodios -->
            <div v-if="state.formData.tiene_custodio" class="col-md-12 mt-3">
              <label class="form-label required"
                >Nombre/s custodio/s policial/es :</label
              >
              <textarea
                class="form-control fuente"
                id="custodios"
                style="text-transform: uppercase"
                v-model.trim="state.formData.custodios"
              />
              <div
                class="input-errors"
                v-for="error of v$.formData.custodios.$errors"
                :key="error.$uid"
              >
                <span class="text-danger" v-if="error.$validator == 'required'"
                  >El nombre o nombres de los custodios son requeridos</span
                >
              </div>
            </div>
            <!-- ¿Tiene fecha inicial y final?-->
            <div
              v-if="esDetencionDomiciliaria"
              class="col-md-3 mt-3 float-left row"
            >
              <label class="form-label required"
                >¿Tiene fechas definidas?:</label
              >
              <br />
              <div class="form-check form-switch mt-2">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="tiene_fechas"
                  v-model="state.formData.tiene_fechas"
                  :onClick="limpiarFechasDefinidas"
                />
                <label class="form-check-label" for="flexSwitchCheckDefault">
                  {{ state.formData.tiene_fechas == true ? "Sí" : "No" }}</label
                >
              </div>
            </div>
            <!-- fecha inicio y final -->
            <div v-if="state.formData.tiene_fechas || esExtramuro" class="row">
              <div class="col-md-6 mt-3">
                <label class="form-label required">Fecha inicial:</label>
                <Datepicker
                  uid="fecha_inicio"
                  v-model="state.formData.fecha_inicio"
                  type="date"
                  locale="es"
                  cancelText="Cancelar"
                  selectText="Seleccionar"
                  monthNameFormat="long"
                  :enableTimePicker="false"
                  :format="format"
                  :previewFormat="format"
                  required
                ></Datepicker>
                <div
                  class="input-errors"
                  v-for="error of v$.formData.fecha_inicio.$errors"
                  :key="error.$uid"
                >
                  <span
                    class="text-danger"
                    v-if="error.$validator == 'required'"
                    >La fecha de inicio es requerida</span
                  >
                </div>
              </div>
              <!-- fecha fin -->
              <div class="col-md-6 mt-3">
                <label class="form-label required">Fecha finalización:</label>
                <Datepicker
                  uid="fecha_traslado"
                  v-model="state.formData.fecha_final"
                  type="date"
                  locale="es"
                  cancelText="Cancelar"
                  selectText="Seleccionar"
                  monthNameFormat="long"
                  :enableTimePicker="false"
                  :format="format"
                  :previewFormat="format"
                  :minDate="state.formData.fecha_inicio"
                  required
                ></Datepicker>
                <!-- <div
                  class="input-errors"
                  v-for="error of v$.formData.fecha_final.$errors"
                  :key="error.$uid"
                >
                  <span
                    class="text-danger"
                    v-if="error.$validator == 'required'"
                    >La fecha de finalización es requerida</span
                  >
                </div> -->
              </div>
            </div>
          </div>
          <!-- observaciones -->
          <div class="col-md-12 mt-3">
            <label class="form-label">Observaciones:</label>
            <textarea
              class="form-control fuente"
              id="telefonoCelular"
              min="1"
              pattern="^[0-9]+"
              style="text-transform: uppercase"
              v-model.trim="state.formData.observacionOrdenes"
            />
          </div>
          <input
            name="estado"
            style="display: none"
            v-model="state.formData.estado"
          />
        </div>
      </div>
    </div>
    <div 
      v-if="tipo"
      class="m-10 d-flex justify-content-end align-items-right"
    >
      <a 
        v-if="!isLoading"
        @click="registerNewOrder()" 
        class="btn btn-primary btn-bg"
        >Registrar</a
      >
      <a 
        v-else
        class="btn btn-primary btn-bg"
        >Espere por favor...</a
      >
    </div>
  </div>
  <!-- loader -->
    <loading
      v-model:active="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      :height="100"
      :width="100"
    ></loading>
    <documentViewer v-if="isDocumentViewerVisible" :documentType="documentType" :documentId="documentId" @close="isDocumentViewerVisible = false"></documentViewer>
</template>
<script>
import {
  defineComponent,
  ref,
  reactive,
  onMounted,
  onUnmounted,
  computed,
  watch,
} from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import Datepicker from "vue3-date-time-picker";
import "vue3-date-time-picker/dist/main.css";
import date from "date-and-time";
import { formatISO } from "date-fns";
import es from "date-and-time/locale/es";
//import vSelect from "vue-select";
import useVuelidate from "@vuelidate/core";
import { requiredIf } from "@vuelidate/validators";
import "vue-select/dist/vue-select.css";
import { addMonths } from "date-fns";
import formatDate from "@/helpers/formatDate";
import formatDateWithHours from "@/helpers/formatDateWithHours";
import filiation from "@/filiation/composables/useFiliation";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { useRouter, useRoute } from "vue-router";
import useAddTransferDeparture from "@/addTransfersDepartures/composables/useAddTransferDeparture";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import documentViewer from "@/views/documentViewer.vue"
//import { useRoute } from "vue-router";
export default defineComponent({
  name: "addOrTransferOrDeparture",
  components: {
    Datepicker,
    Loading,
    documentViewer
  },
  setup() {
    date.locale(es);
    const router = useRouter();
    const route = useRoute();
    const now = new Date();
    const pattern = date.compile("MM DD YYYY");
    const currentDate = date.format(now, pattern);
    const courtsList = ref([]);
    const typeCourtsList = ref([]);
    const typeCodesList = ref([]);
    const typeOrdersList = ref([]);
    const typeOfDeath = ref([]);
    const prisionNamesList = ref([]);
    const crimesList = ref([]);
    const codMandamiento = ref(true);
    const tiempo_sentencia = ref(false);
    const nombre_completo = ref("");
    const tipo_mandamiento = ref("");
    const fotografia = ref("");
    const doc_identidad = ref("");
    const codigo_file_ppl = ref("");
    const tipo_traslado = ref("");
    const descripcion_tipo_mandamiento = ref("");
    const id_persona = computed(() => route.params.id_persona);
    const id_orden_judicial = computed(() => route.params.id_orden_judicial);
    const tipo = computed(() => route.params.tipo);
    const tipo_add = computed(() => route.params.add);
    const esLibertadDefinitiva = ref(false);
    const esDetencionDomiciliaria = ref(false);
    const esExtramuro = ref(false);
    const esLibertadCondicional = ref(false);
    const esPerdonJudicial = ref(false);
    const isLoading = ref(false);
    const state = reactive({
      formData: {
        id_ppl: "",
        fecha_orden: "",
        fecha_traslado: "",
        fecha_libertad: "",
        fecha_ingreso: "",
        anios_sentencia: null,
        meses_sentencia: null,
        fecha_salida: "",
        habilitarFechaSalida: false,
        tipo_mandamiento: "",
        tipo_libertad_definitiva: "",
        motivo_traslado: "",
        nombre_juez: "",
        nombre_juzgado: "",
        tipo_juzgado: "",
        codigo_mandamiento: "",
        tipo_codigo: "",
        centro_penitenciario: "",
        centro_penitenciario_traslado: "",
        delitos: [],
        seguido_por: "",
        observacionOrdenes: "",
        estado: false,
        lugar_detencion_domiciliaria: "",
        motivo_extramuro: "",
        tiene_custodio: false,
        custodios: "",
        tiene_fechas: false,
        fecha_inicio: "",
        fecha_final: "",
        fecha_deceso: "",
        lugar_deceso: "",
        certificado_defuncion: "",
        id_tipo_deceso: "",
        fecha_evasion: "",
        descripcion_evasion: "",
      },
    });
    const formatDateTime = (val) => {
      state.formData.fecha_evasion = formatISO(val, "ppp");
    };
    // reglas para validaciones de campos
    const rules = computed(() => {
      return {
        formData: {
          fecha_orden: {
            required: requiredIf(function () {
              return tipo.value !== "fallecimiento" && tipo.value !== "evasion";
            }),
          },
          fecha_traslado: {
            required: requiredIf(function () {
              return tipo.value === "traslados";
            }),
          },
          fecha_libertad: {
            required: requiredIf(function () {
              return tipo.value === "salidas";
            }),
          },
          tipo_mandamiento: {
            required: requiredIf(function () {
              return tipo.value !== "fallecimiento" && tipo.value !== "evasion";
            }),
          },
          tipo_libertad_definitiva: {
            required: requiredIf(function () {
              return esLibertadDefinitiva.value === true;
            }),
          },
          motivo_traslado: {
            required: requiredIf(function () {
              return tipo.value === "traslados";
            }),
          },
          anios_sentencia: {
            required: requiredIf(function () {
              return tiempo_sentencia.value === true;
            }),
          },
          meses_sentencia: {
            required: requiredIf(function () {
              return tiempo_sentencia.value === true;
            }),
          },
          nombre_juez: {
            required: requiredIf(function () {
              return tipo.value !== "fallecimiento" && tipo.value !== "evasion";
            }),
          },
          nombre_juzgado: {
            required: requiredIf(function () {
              return tipo.value !== "fallecimiento" && tipo.value !== "evasion";
            }),
          },
          tipo_juzgado: {
            required: requiredIf(function () {
              return tipo.value !== "fallecimiento" && tipo.value !== "evasion";
            }),
          },
          tipo_codigo: {
            required: requiredIf(function () {
              return tipo.value !== "fallecimiento" && tipo.value !== "evasion";
            }),
          },
          codigo_mandamiento: {
            required: requiredIf(function () {
              return tipo.value !== "fallecimiento" && tipo.value !== "evasion";
            }),
          },
          centro_penitenciario_traslado: {
            required: requiredIf(function () {
              return tipo.value === "traslados";
            }),
          },
          delitos: {
            required: requiredIf(function () {
              return tipo_add.value === "register";
            }),
          },
          lugar_detencion_domiciliaria: {
            required: requiredIf(function () {
              return (
                esDetencionDomiciliaria.value === true ||
                esExtramuro.value === true
              );
            }),
          },
          motivo_extramuro: {
            required: requiredIf(function () {
              return esExtramuro.value === true;
            }),
          },
          custodios: {
            required: requiredIf(function () {
              return state.formData.tiene_custodio === true;
            }),
          },
          fecha_inicio: {
            required: requiredIf(function () {
              return (
                state.formData.tiene_fechas === true ||
                esExtramuro.value === true
              );
            }),
          },
          fecha_deceso: {
            required: requiredIf(function () {
              return tipo.value === "fallecimiento";
            }),
          },
          lugar_deceso: {
            required: requiredIf(function () {
              return tipo.value === "fallecimiento";
            }),
          },
          certificado_defuncion: {
            required: requiredIf(function () {
              return tipo.value === "fallecimiento";
            }),
          },
          id_tipo_deceso: {
            required: requiredIf(function () {
              return tipo.value === "fallecimiento";
            }),
          },
          fecha_evasion: {
            required: requiredIf(function () {
              return tipo.value === "evasion";
            }),
          },
          descripcion_evasion: {
            required: requiredIf(function () {
              return tipo.value === "evasion";
            }),
          },
          // fecha_final: {
          //   required: requiredIf(function () {
          //     return (
          //       state.formData.tiene_fechas === true ||
          //       esExtramuro.value === true
          //     );
          //   }),
          // },
        },
      };
    });
    const v$ = useVuelidate(rules, state);
    //funcion para formatear fecha
    const format = (date) => {
      const formattedDate = formatDate(date);
      return formattedDate;
    };
    const formatDateAndHours = (date) => {
      const formattedDate = formatDateWithHours(date);
      return formattedDate;
    };
    //importar funciones de useFiliation.js
    const { typeCourts, typeCodes, typeOrders, prisionNames, crimes } =
      filiation();
    const {
      sendAddtransferDeparture,
      printAddTransferDeparture,
      get_types_of_deaths,
    } = useAddTransferDeparture();
    //listar juzgados
    // importar "nameCourts" desde filiation si es necesario
    // const listNameCourts = async () => {
    //   const { data } = await nameCourts();
    //   courtsList.value = data;
    // };
    //listar tipos de juzgados
    const listTypeCourts = async () => {
      const { data } = await typeCourts();
      typeCourtsList.value = data;
    };
    //listar tipos de códigos
    const listTypeCodes = async () => {
      const { data } = await typeCodes();
      typeCodesList.value = data;
    };
    //listar tipos de deceso
    const listTypeOfDeath = async () => {
      const { data } = await get_types_of_deaths();
      typeOfDeath.value = data;
    };
    //listar tipos de ordenes
    const listTypeOrders = async () => {
      const { data } = await typeOrders();
      let list = "";
      if (tipo.value == "salidas") {
        list = ["SALIDA"];
      } else if (tipo.value == "traslados") {
        list = ["TRASLADO"];
      } else if (tipo.value == "nuevo") {
        list = ["DETENCION"];
      } else {
        return;
      }
      const orders = data.filter((el) => list.includes(el.tipo));
      typeOrdersList.value = orders;
    };
    // limpiar campos si tiene o no custodio
    const limpiarCustodios = () => {
      state.formData.custodios = "";
    };
    // limpiar campos si tiene o no fecha definida
    const limpiarFechasDefinidas = () => {
      state.formData.fecha_inicio = "";
      state.formData.fecha_final = "";
    };
    //Listar recintos penitenciarios
    const listPrisionNames = async () => {
      const { data } = await prisionNames();
      const filteredPrisionNames = data.filter(
        (item) => item.nombre_recinto_penitenciario !== "TODOS"
      );
      prisionNamesList.value = filteredPrisionNames;
    };
    //Listar delitos
    const listCrimes = async () => {
      const { data } = await crimes();
      crimesList.value = data;
    };
    const disabledCodMandamiento = async (id_codigo) => {
      const found = typeCodesList.value.find(
        (element) => element.id_tipo_codigo == id_codigo
      );
      if (found === undefined) {
        return;
      } else {
        if (found.nombre_codigo === "SIN CÓDIGO") {
          codMandamiento.value = false;
          state.formData.codigo_mandamiento = "SIN CÓDIGO";
        } else {
          codMandamiento.value = true;
        }
      }
    };
    const habilitarCamposPorTipoMandamiento = (id) => {
      const found = typeOrdersList.value.find(
        (element) => element.id_tipo_mandamiento == id
      );
      if (found === undefined) {
        return;
      } else {
        descripcion_tipo_mandamiento.value = found.descripcion_tipo_mandamiento;
        if (found.descripcion_tipo_mandamiento === "SENTENCIADO") {
          tiempo_sentencia.value = true;
          state.formData.estado = true;
          esDetencionDomiciliaria.value = false;
          esExtramuro.value = false;
          esLibertadDefinitiva.value = false;
        } else if (
          found.descripcion_tipo_mandamiento === "APREMIO" ||
          found.descripcion_tipo_mandamiento === "PREVENTIVO"
        ) {
          tiempo_sentencia.value = false;
          state.formData.anios_sentencia = null;
          state.formData.meses_sentencia = null;
          state.formData.fecha_salida = "";
          state.formData.habilitarFechaSalida = false;
          state.formData.estado = true;
          esDetencionDomiciliaria.value = false;
          esExtramuro.value = false;
          esLibertadDefinitiva.value = false;
        } else if (found.tipo === "TRASLADO") {
          tipo_traslado.value = found.descripcion_tipo_mandamiento;
          state.formData.estado = found.estado;
          esDetencionDomiciliaria.value = false;
          esExtramuro.value = false;
          esLibertadDefinitiva.value = false;
          esPerdonJudicial.value = false;
        } else if (
          found.descripcion_tipo_mandamiento === "DETENCIÓN DOMICILIARIA"
        ) {
          esDetencionDomiciliaria.value = true;
          esExtramuro.value = false;
          esLibertadDefinitiva.value = false;
          esPerdonJudicial.value = false;
          state.formData.estado = found.estado;
          // eslint-disable-next-line prettier/prettier
        } else if (found.descripcion_tipo_mandamiento === "LIBERTAD DEFINITIVA") {
          esLibertadDefinitiva.value = true;
          esDetencionDomiciliaria.value = false;
          esExtramuro.value = false;
          esPerdonJudicial.value = false;
          state.formData.estado = found.estado;
        } else if (found.descripcion_tipo_mandamiento === "EXTRAMURO") {
          esDetencionDomiciliaria.value = false;
          esExtramuro.value = true;
          esLibertadDefinitiva.value = false;
          esPerdonJudicial.value = false;
          state.formData.estado = found.estado;
          // eslint-disable-next-line prettier/prettier
        } else if (found.descripcion_tipo_mandamiento === "LIBERTAD CONDICIONAL") {
          esDetencionDomiciliaria.value = false;
          esExtramuro.value = false;
          esLibertadCondicional.value = true;
          esLibertadDefinitiva.value = false;
          esPerdonJudicial.value = false;
          state.formData.estado = found.estado;
        } else if (found.descripcion_tipo_mandamiento === "PERDÓN JUDICIAL") {
          esDetencionDomiciliaria.value = false;
          esExtramuro.value = false;
          esLibertadCondicional.value = false;
          esLibertadDefinitiva.value = false;
          esPerdonJudicial.value = true;
          state.formData.estado = found.estado;
        }
      }
    };
    const deleteZeros = (e) => {
      var key = e.keyCode || e.charCode;
      if (
        (key == 48 || key == 96) &&
        (state.formData.meses_sentencia[1] == "0" ||
          state.formData.meses_sentencia[1] == 0)
      ) {
        state.formData.meses_sentencia = state.formData.meses_sentencia.replace(
          /^0+/,
          ""
        );
      }
    };
    const calcularFechaSalida = (mes) => {
      const anio = Number(state.formData.anios_sentencia) * 12;
      const total = Number(anio) + Number(mes);
      let valor;
      mes == ""
        ? (state.formData.fecha_salida = " ")
        : (valor = addMonths(Date.parse(state.formData.fecha_ingreso), total));
      return (state.formData.fecha_salida = valor);
    };
    const limpiarFechaSalida = () => {
      state.formData.anios_sentencia = null;
      state.formData.fecha_salida = "";
      state.formData.meses_sentencia = null;
      state.formData.tipo_mandamiento = "";
      state.formData.habilitarFechaSalida = false;
    };
    const cambioMeses = (anios) => {
      anios == 30
        ? (state.formData.meses_sentencia = "0")
        : state.formData.meses_sentencia;
      calcularFechaSalida(state.formData.meses_sentencia);
    };
    const registerNewOrder = async () => {
      // console.log(id_persona);
      // console.log(id_orden_judicial);
      v$.value.$validate();
      if (!v$.value.$error) {
        try {
          isLoading.value=true;
          const params = {
          id_person: id_persona,
          id_order: id_orden_judicial,
          };
          const { data } = await sendAddtransferDeparture({
          dato: state.formData,
          params: params,
          tipo: tipo,
        });
        if (data.ok) {
          isLoading.value=false;
          Swal.fire({
            title: "Registrado",
            text: `${data.message}`,
            icon: "success",
            buttonsStyling: false,
            confirmButtonText: "Continuar",
            customClass: {
              confirmButton: "btn fw-bold btn-light-primary",
            },
          }).then(async () => {
            //resetForm();
            if (tipo.value === "nuevo") {
              router.push({
                name: "listDeprivedLibertybyPrisons",
              });
            } else if (esDetencionDomiciliaria.value) {
              router.push({
                name: "transfersDeparturesOrderList",
                params: {
                  type_order: "detencion_domiciliaria",
                },
              });
            } else if (esExtramuro.value) {
              router.push({
                name: "transfersDeparturesOrderList",
                params: {
                  type_order: "extramuro",
                },
              });
            } else if (esLibertadCondicional.value) {
              router.push({
                name: "transfersDeparturesOrderList",
                params: {
                  type_order: "libertad_condicional",
                },
              });
            } else if (esPerdonJudicial.value) {
              router.push({
                name: "transfersDeparturesOrderList",
                params: {
                  type_order: "perdon_judicial",
                },
              });
            } else {
              router.push({
                name: "transfersDeparturesOrderList",
                params: {
                  type_order: tipo.value,
                },
              });
            }
            // await printAddTransferDeparture({ id: data.id, tipo: tipo.value });
               await viewDocument( tipo.value, data.id );
          });
        } else {
          isLoading.value=false;
          let value = "";
          tipo.value === "traslados"
            ? value == "El traslado no pudo ser registrado"
            : tipo.value === "salidas"
            ? value == "La salida no pudo ser registrada"
            : tipo.value === "fallecimiento"
            ? value == "El registro de fallecimiento no pudo ser registrado"
            : tipo.value === "evasion"
            ? value == "El registro de evasion no pudo ser registrado"
            : "";
          Swal.fire({
            title: "Atención",
            text: `${value},\n por favor contáctese con el administrador`,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Continuar",
            customClass: {
              confirmButton: "btn fw-bold btn-light-primary",
            },
          });
        }
        } catch (error) {
        console.error('Error submitting form:', error);
      }
        
      }
    };
    const isDocumentViewerVisible =ref(false)
    const documentType =ref("")
    const documentId=ref("")
    const viewDocument = async (type, id) => {
      isDocumentViewerVisible.value=true
      documentId.value=id;
      documentType.value=type;
    };
    watch(esDetencionDomiciliaria, (value) => {
      if (!value) {
        state.formData.lugar_detencion_domiciliaria = "";
        state.formData.tiene_custodio = false;
        state.formData.custodios = "";
        state.formData.fecha_inicio = "";
        state.formData.fecha_final = "";
      }
    });
    watch(esExtramuro, (value) => {
      if (!value) {
        state.formData.lugar_detencion_domiciliaria = "";
        state.formData.motivo_extramuro = "";
        state.formData.fecha_inicio = "";
        state.formData.fecha_final = "";
      }
    });
    onMounted(() => {
      let t = "";
      if (tipo.value == "traslados") {
        t = "traslado";
      } else if (tipo.value == "salidas") {
        t = "salida";
      } else if (tipo.value == "nuevo") {
        t = "nueva orden judicial";
      } else if (tipo.value == "fallecimiento") {
        t = "fallecimiento";
      } else if (tipo.value == "evasion") {
        t = "evasión";
      }
      setCurrentPageBreadcrumbs(`Registro de ${t}`, ["Privado de libertad"]);
      //listNameCourts();
      listTypeCourts();
      listTypeCodes();
      listTypeOfDeath();
      listTypeOrders();
      listPrisionNames();
      listCrimes();
      //inicio cargado de datos para edición
      const data = JSON.parse(localStorage.getItem("edit") || "{}");
      if (Object.entries(data).length !== 0) {
        codigo_file_ppl.value = data.general[0].codigo_file_ppl;
        doc_identidad.value =
          data.general[0].nombre_tipo_documento_identidad +
          " " +
          data.general[0].nro_documento;
        nombre_completo.value =
          data.general[0].nombres +
          " " +
          data.general[0].primer_apellido +
          " " +
          data.general[0].segundo_apellido;
        tipo_mandamiento.value = data.general[0].descripcion_tipo_mandamiento;
        state.formData.id_ppl = data.general[0].id_persona;
        fotografia.value = data.general[0].imagen_segip;
        state.formData.centro_penitenciario =
          data.general[0].cod_recinto_penitenciario;
        for (let del of data.delitos) {
          state.formData.delitos.push(del.cod_delito);
        }
        if (tipo.value === "nuevo" && tipo_add.value === "add") {
          state.formData.fecha_ingreso = data.general[0].fecha_ingreso_recinto;
        }
      }
      //fin cargado de datos
    });
    onUnmounted(() => {
      localStorage.removeItem("edit");
    });
    return {
      doc_identidad,
      codigo_file_ppl,
      nombre_completo,
      tipo_mandamiento,
      fotografia,
      tipo,
      currentDate,
      courtsList,
      typeCourtsList,
      typeCodesList,
      typeOrdersList,
      typeOfDeath,
      prisionNamesList,
      crimesList,
      state,
      codMandamiento,
      format,
      formatDateAndHours,
      setCurrentPageBreadcrumbs,
      //listNameCourts,
      listTypeCourts,
      listTypeCodes,
      listTypeOfDeath,
      listPrisionNames,
      listCrimes,
      disabledCodMandamiento,
      habilitarCamposPorTipoMandamiento,
      cambioMeses,
      deleteZeros,
      calcularFechaSalida,
      limpiarFechaSalida,
      registerNewOrder,
      limpiarCustodios,
      limpiarFechasDefinidas,
      tiempo_sentencia,
      id_orden_judicial,
      tipo_add,
      tipo_traslado,
      descripcion_tipo_mandamiento,
      esDetencionDomiciliaria,
      esExtramuro,
      esLibertadDefinitiva,
      v$,
      formatDateTime,
      isLoading,
      viewDocument,
      isDocumentViewerVisible,
      documentType,
      documentId
    };
  },
});
</script>
<style>
.image {
  text-align: right;
  padding-bottom: 3em;
}
p.round3 {
  border: 1px solid;
  border-radius: 5px;
  border-left-width: 7px;
  border-left-color: #037915;
  padding: 10px;
}
.fuente {
  font-size: 0.97em;
  padding: 0.35em;
  font-weight: normal;
}
@media screen and (max-width: 767px) {
  .image {
    text-align: center !important;
  }
}
</style>
